import { render, staticRenderFns } from "./SearchFields.vue?vue&type=template&id=36931228&scoped=true&"
import script from "./SearchFields.vue?vue&type=script&lang=js&"
export * from "./SearchFields.vue?vue&type=script&lang=js&"
import style0 from "./SearchFields.vue?vue&type=style&index=0&id=36931228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36931228",
  null
  
)

export default component.exports